import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { HttpHeaders } from "@azure/core-http";
import { HTTP_VERSION_1_1, HTTP_LINE_ENDING, HeaderConstants, HTTPURLConnection } from "./utils/constants";
import { getBodyAsText } from "./BatchUtils";
import { logger } from "./log";
var HTTP_HEADER_DELIMITER = ": ";
var SPACE_DELIMITER = " ";
var NOT_FOUND = -1;
/**
 * Util class for parsing batch response.
 */

export var BatchResponseParser = /*#__PURE__*/function () {
  function BatchResponseParser(batchResponse, subRequests) {
    _classCallCheck(this, BatchResponseParser);

    if (!batchResponse || !batchResponse.contentType) {
      // In special case(reported), server may return invalid content-type which could not be parsed.
      throw new RangeError("batchResponse is malformed or doesn't contain valid content-type.");
    }

    if (!subRequests || subRequests.size === 0) {
      // This should be prevent during coding.
      throw new RangeError("Invalid state: subRequests is not provided or size is 0.");
    }

    this.batchResponse = batchResponse;
    this.subRequests = subRequests;
    this.responseBatchBoundary = this.batchResponse.contentType.split("=")[1];
    this.perResponsePrefix = "--".concat(this.responseBatchBoundary).concat(HTTP_LINE_ENDING);
    this.batchResponseEnding = "--".concat(this.responseBatchBoundary, "--");
  } // For example of response, please refer to https://docs.microsoft.com/en-us/rest/api/storageservices/blob-batch#response


  _createClass(BatchResponseParser, [{
    key: "parseBatchResponse",
    value: function () {
      var _parseBatchResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var responseBodyAsText, subResponses, subResponseCount, deserializedSubResponses, subResponsesSucceededCount, subResponsesFailedCount, index, subResponse, deserializedSubResponse, responseLines, subRespHeaderStartFound, subRespHeaderEndFound, subRespFailed, contentId, _iterator, _step, responseLine, tokens, _tokens;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.batchResponse._response.status !== HTTPURLConnection.HTTP_ACCEPTED)) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Invalid state: batch request failed with status: '".concat(this.batchResponse._response.status, "'."));

              case 2:
                _context.next = 4;
                return getBodyAsText(this.batchResponse);

              case 4:
                responseBodyAsText = _context.sent;
                subResponses = responseBodyAsText.split(this.batchResponseEnding)[0] // string after ending is useless
                .split(this.perResponsePrefix).slice(1); // string before first response boundary is useless

                subResponseCount = subResponses.length; // Defensive coding in case of potential error parsing.
                // Note: subResponseCount == 1 is special case where sub request is invalid.
                // We try to prevent such cases through early validation, e.g. validate sub request count >= 1.
                // While in unexpected sub request invalid case, we allow sub response to be parsed and return to user.

                if (!(subResponseCount !== this.subRequests.size && subResponseCount !== 1)) {
                  _context.next = 9;
                  break;
                }

                throw new Error("Invalid state: sub responses' count is not equal to sub requests' count.");

              case 9:
                deserializedSubResponses = new Array(subResponseCount);
                subResponsesSucceededCount = 0;
                subResponsesFailedCount = 0; // Parse sub subResponses.

                index = 0;

              case 13:
                if (!(index < subResponseCount)) {
                  _context.next = 59;
                  break;
                }

                subResponse = subResponses[index];
                deserializedSubResponse = {};
                deserializedSubResponse.headers = new HttpHeaders();
                responseLines = subResponse.split("".concat(HTTP_LINE_ENDING));
                subRespHeaderStartFound = false;
                subRespHeaderEndFound = false;
                subRespFailed = false;
                contentId = NOT_FOUND;
                _iterator = _createForOfIteratorHelper(responseLines);
                _context.prev = 23;

                _iterator.s();

              case 25:
                if ((_step = _iterator.n()).done) {
                  _context.next = 46;
                  break;
                }

                responseLine = _step.value;

                if (subRespHeaderStartFound) {
                  _context.next = 31;
                  break;
                }

                // Convention line to indicate content ID
                if (responseLine.startsWith(HeaderConstants.CONTENT_ID)) {
                  contentId = parseInt(responseLine.split(HTTP_HEADER_DELIMITER)[1]);
                } // Http version line with status code indicates the start of sub request's response.
                // Example: HTTP/1.1 202 Accepted


                if (responseLine.startsWith(HTTP_VERSION_1_1)) {
                  subRespHeaderStartFound = true;
                  tokens = responseLine.split(SPACE_DELIMITER);
                  deserializedSubResponse.status = parseInt(tokens[1]);
                  deserializedSubResponse.statusMessage = tokens.slice(2).join(SPACE_DELIMITER);
                }

                return _context.abrupt("continue", 44);

              case 31:
                if (!(responseLine.trim() === "")) {
                  _context.next = 34;
                  break;
                }

                // Sub response's header start line already found, and the first empty line indicates header end line found.
                if (!subRespHeaderEndFound) {
                  subRespHeaderEndFound = true;
                }

                return _context.abrupt("continue", 44);

              case 34:
                if (subRespHeaderEndFound) {
                  _context.next = 42;
                  break;
                }

                if (!(responseLine.indexOf(HTTP_HEADER_DELIMITER) === -1)) {
                  _context.next = 37;
                  break;
                }

                throw new Error("Invalid state: find non-empty line '".concat(responseLine, "' without HTTP header delimiter '").concat(HTTP_HEADER_DELIMITER, "'."));

              case 37:
                // Parse headers of sub response.
                _tokens = responseLine.split(HTTP_HEADER_DELIMITER);
                deserializedSubResponse.headers.set(_tokens[0], _tokens[1]);

                if (_tokens[0] === HeaderConstants.X_MS_ERROR_CODE) {
                  deserializedSubResponse.errorCode = _tokens[1];
                  subRespFailed = true;
                }

                _context.next = 44;
                break;

              case 42:
                // Assemble body of sub response.
                if (!deserializedSubResponse.bodyAsText) {
                  deserializedSubResponse.bodyAsText = "";
                }

                deserializedSubResponse.bodyAsText += responseLine;

              case 44:
                _context.next = 25;
                break;

              case 46:
                _context.next = 51;
                break;

              case 48:
                _context.prev = 48;
                _context.t0 = _context["catch"](23);

                _iterator.e(_context.t0);

              case 51:
                _context.prev = 51;

                _iterator.f();

                return _context.finish(51);

              case 54:
                // Inner for end
                // The response will contain the Content-ID header for each corresponding subrequest response to use for tracking.
                // The Content-IDs are set to a valid index in the subrequests we sent. In the status code 202 path, we could expect it
                // to be 1-1 mapping from the [0, subRequests.size) to the Content-IDs returned. If not, we simply don't return that
                // unexpected subResponse in the parsed reponse and we can always look it up in the raw response for debugging purpose.
                if (contentId !== NOT_FOUND && Number.isInteger(contentId) && contentId >= 0 && contentId < this.subRequests.size && deserializedSubResponses[contentId] === undefined) {
                  deserializedSubResponse._request = this.subRequests.get(contentId);
                  deserializedSubResponses[contentId] = deserializedSubResponse;
                } else {
                  logger.error("subResponses[".concat(index, "] is dropped as the Content-ID is not found or invalid, Content-ID: ").concat(contentId));
                }

                if (subRespFailed) {
                  subResponsesFailedCount++;
                } else {
                  subResponsesSucceededCount++;
                }

              case 56:
                index++;
                _context.next = 13;
                break;

              case 59:
                return _context.abrupt("return", {
                  subResponses: deserializedSubResponses,
                  subResponsesSucceededCount: subResponsesSucceededCount,
                  subResponsesFailedCount: subResponsesFailedCount
                });

              case 60:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[23, 48, 51, 54]]);
      }));

      function parseBatchResponse() {
        return _parseBatchResponse.apply(this, arguments);
      }

      return parseBatchResponse;
    }()
  }]);

  return BatchResponseParser;
}();